import React from 'react';
import './PlayerStat.css'

const PlayerStat = (props) => {
  const {
    color,
    icon,
    text,
    className,
    noShrinkOnMobile,
    title,
  } = props;

  return (
    <div
      className={`player-stat ${className || ''} ${noShrinkOnMobile ? 'no-shrink-on-mobile' : ''}`}
      style={{
        color,
      }}
    >
      <span>
        {text}
      </span>
      <img
        src={icon}
        alt="-"
        title={title}
      />
    </div>
  );
};

export default PlayerStat;